import { handleActions } from 'modules/helpers';

import { ActionTypes } from 'constants/index';

export const healthCheckState = {
  list: [],
  pagination: { limit: 10, offset: 0 },
  loading: false,
  metrics: null,
  metricsLoading: false,
  reportDetail: null,
  reportDetailsById: {},
  reportLoading: false,
  reportError: null,
  selectedReportId: null,
  selectedReportLoading: false,
  selectedReportError: null,
  railReportLoading: false,
  railReportError: null,
  startHealthCheckLoading: false,
  startHealthCheckError: null,
  lastHealthCheckForLocation: null,
  lastHealthCheckForLocationLoading: false,
  lastHealthCheckForLocationError: null,
};

export default {
  healthCheck: handleActions(
    {
      [ActionTypes.START_HEALTH_CHECK]: draft => {
        draft.startHealthCheckLoading = true;
        draft.startHealthCheckError = null;
      },
      [ActionTypes.START_HEALTH_CHECK_SUCCESS]: draft => {
        draft.startHealthCheckLoading = false;
        draft.startHealthCheckError = null;
      },
      [ActionTypes.START_HEALTH_CHECK_FAILURE]: (draft, { payload }) => {
        draft.startHealthCheckLoading = false;
        draft.startHealthCheckError = payload || 'Error running health check';
      },
      [ActionTypes.GET_HEALTH_CHECKS]: draft => {
        draft.loading = true;
      },
      [ActionTypes.GET_HEALTH_CHECKS_SUCCESS]: (draft, { payload: { list, pagination } }) => {
        draft.list = list;
        draft.pagination = pagination || draft.pagination;
        draft.loading = false;
      },
      [ActionTypes.GET_HEALTH_CHECKS_FAILURE]: draft => {
        draft.loading = false;
      },
      [ActionTypes.GET_HEALTH_CHECK_METRICS]: draft => {
        draft.metricsLoading = true;
      },
      [ActionTypes.GET_HEALTH_CHECK_METRICS_SUCCESS]: (draft, { payload }) => {
        draft.metrics = payload;
        draft.metricsLoading = false;
      },
      [ActionTypes.GET_HEALTH_CHECK_METRICS_FAILURE]: draft => {
        draft.metricsLoading = false;
      },
      [ActionTypes.GET_HEALTH_CHECK_REPORT]: (draft, { payload }) => {
        const { reportId, meta = {} } = payload || {};
        if (meta.role === 'rail') {
          draft.railReportLoading = true;
          draft.railReportError = null;
          return;
        }

        draft.selectedReportId = reportId || null;
        draft.selectedReportLoading = true;
        draft.selectedReportError = null;
        draft.reportLoading = true;
        draft.reportError = null;
      },
      [ActionTypes.GET_HEALTH_CHECK_REPORT_SUCCESS]: (draft, { payload }) => {
        const { report, reportId, meta = {} } = payload || {};
        const resolvedReportId = report?.report_id ?? reportId;

        if (!draft.reportDetailsById) {
          draft.reportDetailsById = {};
        }

        if (resolvedReportId != null && resolvedReportId !== '') {
          draft.reportDetailsById[String(resolvedReportId)] = report;
        }

        if (meta.role === 'rail') {
          draft.railReportLoading = false;
          draft.railReportError = null;
          return;
        }

        draft.reportDetail = report;
        draft.selectedReportId = resolvedReportId || reportId || null;
        draft.selectedReportLoading = false;
        draft.selectedReportError = null;
        draft.reportLoading = false;
        draft.reportError = null;
      },
      [ActionTypes.GET_HEALTH_CHECK_REPORT_FAILURE]: (draft, { payload }) => {
        const { error, reportId, meta = {} } = payload || {};
        const message = error || 'Error loading report';

        if (meta.role === 'rail') {
          draft.railReportLoading = false;
          draft.railReportError = message;
          return;
        }

        draft.selectedReportId = reportId || draft.selectedReportId;
        draft.selectedReportLoading = false;
        draft.selectedReportError = message;
        draft.reportLoading = false;
        draft.reportError = message;
      },
      [ActionTypes.GET_LAST_HEALTH_CHECK_FOR_LOCATION]: draft => {
        draft.lastHealthCheckForLocationLoading = true;
        draft.lastHealthCheckForLocationError = null;
      },
      [ActionTypes.GET_LAST_HEALTH_CHECK_FOR_LOCATION_SUCCESS]: (draft, { payload }) => {
        draft.lastHealthCheckForLocation = payload;
        draft.lastHealthCheckForLocationLoading = false;
        draft.lastHealthCheckForLocationError = null;
      },
      [ActionTypes.GET_LAST_HEALTH_CHECK_FOR_LOCATION_FAILURE]: (draft, { payload }) => {
        draft.lastHealthCheckForLocation = null;
        draft.lastHealthCheckForLocationLoading = false;
        draft.lastHealthCheckForLocationError = payload || 'Error loading last health check';
      },
    },
    healthCheckState,
  ),
};
